<template>
    <v-container full>
        <v-row>
            <v-col>
                <v-card :disabled="loading" :loading="loading">
                    <v-card-title>
                        Sales by Fitter
                        <v-spacer />
                        <v-btn v-if="sales" outlined prepend-icon="mdi-cloud-download" @click="downloadData()">
                            Download data
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <Fitter v-model="fitter"/>
                            </v-col>
                            <v-col>
                                <v-menu
                                    ref="rangeMenu"
                                    v-model="rangeMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="range"
                                            label="Date Range"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                        <v-date-picker
                                            v-model="range"
                                            no-title
                                            scrollable
                                            range
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.rangeMenu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn outlined color="accent" @click="generate">Generate</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="sales">
            <v-col>
                <v-data-table
                    :items="sales"
                    :headers="headers"
                >
                    <template #group.header="{group, items}">
                        <td :colspan="headers.length-2">Month : {{group}}</td>
                        <td>Total</td>
                        <td>{{ items.reduce((total, order) => total + order.price, 0) }}</td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import NewApiService from "@/utils/new.api.service";
import Fitter from '../../components/forms/select/Fitter.vue';
import moment from 'moment'
import fr from 'moment/locale/fr'
moment.updateLocale('fr', fr)

export default {
    components: { Fitter },
    data: () => ({
        rangeMenu: null,
        range:null,
        fitter: null,
        download:0,
        loading:false,
        sales: null,
        error: null,
        headers: [
            {text: '#Order', value: 'id'},
            {text: 'Status', value: 'statusId'},
            {text: 'Validation Date', value: 'validationDate'},
            {text: 'Client', value: 'client.displayName'},
            {text: 'Currency', value: 'currency.currency'},
            {text: 'Price', value: 'price'},
        ],
    }),
    methods: {
        generate() {
            this.loading = true;
            this.sales = null
            this.request()
                .then(({sales}) => {
                    this.sales = sales
                })
                .finally(() => {
                    this.loading=false
                })
        },
        downloadData () {
            this.download=1
            this.request()
                .then((data) => {
                    this.forceFileDownload(data)
                })
                .finally(() => {
                    this.download=0
                })
        },
        request() {
            return new Promise((resolve, reject) => {
                NewApiService.get(`admin/reporting/sales-by-fitter`, {
                    range: this.range,
                    fitter: this.fitter,
                    download: this.download
                })
                    .then(({ data }) => {
                        resolve(data)
                    })
                    .catch(({ response }) => {
                        this.error = response.data.message
                        reject(response)
                    })
            })
        },
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", 'sales_by_fitter.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
    }
}
</script>